import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = (): null => {
  const location = useLocation();
  const prevLocationRef = useRef(location.pathname);

  useEffect(() => {
    // Only scroll to top if the pathname actually changed
    if (prevLocationRef.current !== location.pathname) {
      // Use requestAnimationFrame to ensure DOM is ready
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      prevLocationRef.current = location.pathname;
    }
  }, [location]);

  return null;
};

export default ScrollToTop;
